import Veraportal from "./Veraportal";
import {IPortalseite, ISchueler_testsAPI, TFach} from "./Interfaces";
import {IGruppenDB} from "./InterfacesDB";
import Utilities from "./Utilities";
import Tooltip from './Tooltip';

type TErgebnisstatus = 'ausstehend' | 'vollstaendig' | 'unvollstaendig' | 'keine-daten' | 'keine-cbt-daten' | 'nicht-anwesend' | 'nicht-verfuegbar';

interface IErgebnisstatus {
    cssKlasse: TErgebnisstatus;
    icon: string;
    kurztext: string;
    tooltip: string;
}

export default class Statusuebersicht extends Veraportal implements IPortalseite {
    override async onSeiteLoad(): Promise<boolean> {
        let stammklassenDom = document.querySelector(`.bestelluebersicht > div.stammklassen > div`) as HTMLDivElement ?? null;
        let kurseDom = document.querySelector(`.bestelluebersicht > div.kurse > div`) as HTMLDivElement ?? null;

        if (
            stammklassenDom !== null &&
            this.gruppenliste.filter((g) => g.typ === 'STAMMKLASSE').length > 0
        )
            stammklassenDom.innerHTML = this.gruppenliste
                .filter((g) => g.typ === 'STAMMKLASSE')
                .map(this.gruppeHTML)
                .join('');
        const kurse = this.gruppenliste
            .filter((g) => ['KURS', 'LERNGRUPPE'].includes(g.typ))
            .filter((g) => g.typ === 'KURS' || this.sessionvariablen.user.accounttyp === 2 || g.user_id === this.sessionvariablen.user.user_id);
        const faecher: TFach[] = ['ma', 'de', 'en', 'fr'];
        if (kurseDom !== null && kurse.length > 0)
            kurseDom.innerHTML = faecher.map(fach => {
                const fachkurse = kurse.filter(g => g.kurs_fach === fach);
                if (fachkurse.length === 0)
                    return '';

                return `<section class="kurs-fach"><h3>${Utilities.printFachLang(fach)}</h3>${fachkurse.map(this.gruppeHTML).join('')}</section>`;
            }).join('');

        return true;
    }

    override async onSeiteFinished(): Promise<boolean> {
        document.querySelectorAll<HTMLButtonElement>('.bestelluebersicht button.fach-toggle').forEach((button: HTMLButtonElement) => {
            button.addEventListener('click', () => {
                const fach = button.closest<HTMLDivElement>('div.fach');
                if (fach === null)
                    return;

                const istAusgeklappt = fach.dataset.ausgeklappt === '1';
                fach.dataset.ausgeklappt = istAusgeklappt ? '0' : '1';
                button.setAttribute('aria-expanded', istAusgeklappt ? 'false' : 'true');
            });
        });

        return true;
    }

    override async onSeiteLeave(): Promise<boolean> {

        return true;
    }


    private gruppeHTML = (
        {
            gruppe_id,
            bezeichnung,
            typ,
            testheft_mathematik,
            testheft_deutsch,
            testheft_englisch,
            testheft_franzoesisch,
            is_cbt_mathematik,
            is_cbt_deutsch,
            is_cbt_englisch,
            is_cbt_franzoesisch
        }: IGruppenDB): string => {

        let schuelerInGruppe = this.schuelerliste
            .filter(
                s =>
                    this.schuelerGruppenZuweisungen
                        .filter(x => x.gruppe_id === gruppe_id)
                        .map(x => x.schueler_id)
                        .includes(s.schueler_id) &&
                    s.is_deaktiviert === 0
            );

        let alleTestsInGruppe = this.testliste
            .filter(
                t => {
                    return (
                        t.testgruppe_id === gruppe_id && 1 &&
                        schuelerInGruppe.map(s => s.schueler_id).includes(t.schueler_id)
                    )
                }
            );

        const kursfach =
            alleTestsInGruppe.find(t => t.fach === 'ma' || t.fach === 'de')?.fach ?? null;
        const bezeichnungEncoded = encodeURIComponent(bezeichnung);
        const eigenschaftenAnpassenText = (typ === 'STAMMKLASSE')
            ? 'Stammklasse anpassen'
            : (typ === 'LERNGRUPPE') ? 'Lerngruppe anpassen' : 'Kurs anpassen';

        return `
        <div class="gruppe">
            <div class="gruppe-kopf">
                <div class="gruppe-bezeichnung" data-tooltip="${Tooltip.html`
                    <p><strong>${(typ === 'STAMMKLASSE') ? 'Stammklasse' : 'Kurs'} ${bezeichnung}</strong></p>
                    <p><strong>${schuelerInGruppe.length}</strong> Schülerinnen und Schüler sind ${(typ === 'STAMMKLASSE') ? 'dieser Stammklasse' : 'diesem Kurs'} zugeordnet.</p>
                `}">
                    <span class="gruppenname">
                        <svg role="graphics-symbol" aria-hidden="true"><use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#${typ === 'STAMMKLASSE' ? 'people-fill' : 'calendar2-week'}"/></svg>
                        ${bezeichnung}
                    </span>
                    ${schuelerInGruppe.length === 0 ? `
                        <span class="gruppe-warnung">
                            Keine Schülerinnen und Schüler zugeordnet
                        </span>
                    ` : ''}
                </div>
                ${(this.sessionvariablen.schule.land !== 'ni') ? `
                    <button type="button" class="gruppe-bearbeiten edit-${typ.toLowerCase()}-btn secondary small" aria-label="${eigenschaftenAnpassenText}" data-gruppeid="${gruppe_id}">
                        <svg role='graphics-symbol'>
                        <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#gear-fill'/>
                        </svg>
                        <span>${eigenschaftenAnpassenText}</span>
                    </button>
                ` : ``}
                ${(this.sessionvariablen.schule.land === 'ni' && this.sessionvariablen.user.accounttyp === 5 && kursfach !== null) ? `
                <div>
                <a class="material" href="https://survey.rptu.de/index.php/817817?kursfach=${kursfach}&gruppeid=${gruppe_id}&bezeichnung=${bezeichnungEncoded}" target="_blank" role="button"">
                 <svg role='graphics-symbol' width='30' height='30'>
                            <use href='../lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#file-earmark-bar-graph'/>
                 </svg>
                 Umfrage zur Teilnahme am Förderprogramm
                 </a> 
                </div>
                ` : ``}
            </div>
            <div class="container">
            ${
            this.fachHTML({
                fach: 'ma',
                testheft_id: testheft_mathematik,
                gruppe_id: gruppe_id,
                is_cbt: is_cbt_mathematik,
                testsInFach: alleTestsInGruppe.filter(t => t.fach === 'ma')
            })}
            ${
            this.fachHTML({
                fach: 'de',
                testheft_id: testheft_deutsch,
                gruppe_id: gruppe_id,
                is_cbt: is_cbt_deutsch,
                testsInFach: alleTestsInGruppe.filter(t => t.fach === 'de')
            })}
            ${
            this.fachHTML({
                fach: 'en',
                testheft_id: testheft_englisch,
                gruppe_id: gruppe_id,
                is_cbt: is_cbt_englisch,
                testsInFach: alleTestsInGruppe.filter(t => t.fach === 'en')
            })}
            ${
            this.fachHTML({
                fach: 'fr',
                testheft_id: testheft_franzoesisch,
                gruppe_id: gruppe_id,
                is_cbt: is_cbt_franzoesisch,
                testsInFach: alleTestsInGruppe.filter(t => t.fach === 'fr')
            })}
            </div>
        </div>
        `;
    };

    private fachHTML = (
        {
            fach,
            testheft_id,
            gruppe_id,
            is_cbt,
            testsInFach
        }: { fach: TFach, testheft_id: number, gruppe_id: number, is_cbt: number, testsInFach: ISchueler_testsAPI[] }): string => {
        if (testheft_id === null)
            return '';
        if (testsInFach.length < 1)
            return '';

        const fachId = `testgruppe-${gruppe_id}-${fach}`;
        const istAusgeklappt = this.sessionvariablen.user.accounttyp === 5;
        const cbtZugangscodesVerfuegbar = document.querySelector<HTMLElement>('#statusuebersicht')?.dataset.cbtZugangscodesVerfuegbar === '1';
        const downloadStartAm = this.sessionvariablen.land.testmaterialien_download_start_am ?? null;
        const cbtTooltip = !cbtZugangscodesVerfuegbar && downloadStartAm ? Tooltip.html`
            <p>Ab dem ${new Date(downloadStartAm).toLocaleDateString('de-DE', {day: '2-digit', month: '2-digit', year: 'numeric'})} können Sie hier die CBT-Zugangscodes für Ihre Lerngruppe herunterladen.</p>
        ` : '';

        return `
            <div class="fach ${fach} ${(is_cbt === 1) ? `cbt` : ``}" data-ausgeklappt="${istAusgeklappt ? 1 : 0}">
                <div class="fach-kopf">
                    <button type="button" class="fach-toggle" aria-expanded="${istAusgeklappt}" aria-controls="${fachId}">
                    <span class="caret no-print" aria-hidden="true">
                        <svg role="graphics-symbol" class="caret-right">
                            <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#caret-right-fill"/>
                        </svg>
                        <svg role="graphics-symbol" class="caret-down">
                            <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#caret-down-fill"/>
                        </svg>
                    </span>
                    <span class="fach-bezeichnung" data-tooltip="${Tooltip.html`
                        <p><strong>${Utilities.printFachLang(fach)} anzeigen</strong></p>
                        <p>Klappen Sie die Testgruppe aus, um die zugeordneten Schülerinnen und Schüler und deren Ergebnisstatus einzusehen.</p>
                    `}">${Utilities.printFachLang(fach)}</span>
                    <span class="testheft-bezeichnung">
                        ${this.testheftliste.filter(t => t.testheft_id === testheft_id)[0].bezeichnung}
                        ${(this.sessionvariablen.projekt.weiche === 'vera5') ? `` : (is_cbt === 1) ? `CBT` : `PP`}
                        ${(this.sessionvariablen.projekt.weiche === 'vera5') ? `<span class="only-print">(${(is_cbt === 1) ? `CBT` : `PP`})</span>` : ``}
                    </span>
                    <span class="anzahl"
                         data-tooltip="${Tooltip.html`
                             <p><strong>Testgruppe ${Utilities.printFachLang(fach)}</strong></p>
                             <p><strong>${testsInFach.length}</strong> Schülerinnen und Schüler nehmen aufgrund ihrer Stammklassen- beziehungsweise Kurszuordnung teil.</p>
                         `}">
                        ${testsInFach.length} SuS</span>
                    </button>
                    ${(is_cbt === 1) ? `
                        <div class="cbt">
                            <span class="cbt-download" ${cbtTooltip ? `data-tooltip="${cbtTooltip}"` : ''}>
                            ${cbtZugangscodesVerfuegbar ? `<a role="button" class="small cbt-download-button" href="/cbt-zugangscodeliste.php?print=1&gruppe=${gruppe_id}&testheft=${testheft_id}" target="_blank">` : `<button type="button" class="small cbt-download-button" disabled>`}
                                <svg role="graphics-symbol">
                                    <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#filetype-pdf"/>
                                </svg>
                                CBT-Zugangscodes
                            ${cbtZugangscodesVerfuegbar ? `</a>` : `</button>`}
                            </span>
                        </div>
                    ` : ``}
                </div>
                <div class="schueler-anzeige" id="${fachId}">
                    <div class="container">
                        ${testsInFach.map((test: ISchueler_testsAPI) => this.schuelerHTML(test, is_cbt === 1)).join('')}
                    </div>
                </div>
            </div>
        `;
    };

    private schuelerHTML = (
        test: ISchueler_testsAPI,
        istCbtGruppe: boolean
    ): string => {
        const {schueler_id} = test;
        let schueler = this.schuelerliste.filter(s => s.schueler_id === schueler_id)[0];
        const geschlechtFehlt = schueler.geschlecht === null || schueler.geschlecht === undefined;
        const status = this.ergebnisstatus(test, istCbtGruppe, geschlechtFehlt);

        return `
            <div class="schueler status-${status.cssKlasse}" data-schuelerid="${schueler_id}">
                <svg role="graphics-symbol" class="status-icon" aria-hidden="true" data-tooltip="${status.tooltip}">
                    <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#${status.icon}"/>
                </svg>
                <span class="schueler-name" data-tresor-anzeige="schueler" data-nr="${schueler.nr}" data-left="${schueler.nr.toString().padStart(3, '0')} ">Schüler:in ${schueler.nr.toString().padStart(3, '0')}</span>
                <span class="status-text" data-tooltip="${status.tooltip}">${status.kurztext}</span>
            </div>
        `;
    };

    private ergebnisstatus(test: ISchueler_testsAPI, istCbtGruppe: boolean, geschlechtFehlt: boolean): IErgebnisstatus {
        const anzahlErwartet = this.anzahlErwarteteErgebnisse(test);
        const anzahlVorhanden = test.ergebnisse.length;
        const anzahlFehlend = Math.max(anzahlErwartet - anzahlVorhanden, 0);

        if (test.nicht_anwesend === 1) {
            return {
                cssKlasse: 'nicht-anwesend',
                icon: 'dash-square',
                kurztext: 'Nicht anwesend',
                tooltip: Tooltip.html`
                    <p><strong>Nicht anwesend</strong></p>
                    <p>Die Schülerin oder der Schüler wurde für diesen Test als nicht anwesend markiert.</p>
                `
            };
        }

        if (anzahlErwartet === 0) {
            if (geschlechtFehlt) {
                return this.fehlendesGeschlechtStatus(
                    'Geschlecht fehlt',
                    'Für dieses Testheft sind derzeit noch keine auswertbaren Items hinterlegt.'
                );
            }

            return {
                cssKlasse: 'nicht-verfuegbar',
                icon: 'square',
                kurztext: 'Status noch nicht verfügbar',
                tooltip: Tooltip.html`
                    <p><strong>Ergebnisstatus noch nicht verfügbar</strong></p>
                    <p>Für dieses Testheft sind derzeit noch keine auswertbaren Items hinterlegt.</p>
                `
            };
        }

        if (anzahlVorhanden === anzahlErwartet) {
            if (geschlechtFehlt) {
                return this.fehlendesGeschlechtStatus(
                    'Geschlecht fehlt',
                    `Die Ergebnisdaten für alle ${anzahlErwartet} Items dieses Tests sind vollständig.`
                );
            }

            return {
                cssKlasse: 'vollstaendig',
                icon: 'check-square-fill',
                kurztext: 'Vollständig',
                tooltip: Tooltip.html`
                    <p><strong>Ergebnisdaten vollständig</strong></p>
                    <p>Für alle <strong>${anzahlErwartet}</strong> Items dieses Tests liegen Ergebnisdaten vor.</p>
                `
            };
        }

        if (anzahlVorhanden > 0) {
            if (geschlechtFehlt) {
                return this.fehlendesGeschlechtStatus(
                    `Geschlecht / ${this.fehlendeErgebnisseText(anzahlFehlend)}`,
                    `${anzahlVorhanden} von ${anzahlErwartet} erforderlichen Ergebnissen wurden eingegeben.`
                );
            }

            return this.unvollstaendigerErgebnisstatus(anzahlVorhanden, anzahlErwartet, anzahlFehlend);
        }

        const eingabestart = this.sessionvariablen.land.ergebnisdateneingabe_start_am ?? null;
        const startzeit = eingabestart === null ? NaN : new Date(eingabestart.replace(' ', 'T')).getTime();
        const durchfuehrungBegonnen = Number.isFinite(startzeit) && this.portalzeit.getTime() >= startzeit;
        if (!durchfuehrungBegonnen) {
            if (geschlechtFehlt) {
                return this.fehlendesGeschlechtStatus(
                    'Geschlecht fehlt',
                    'Für diesen Test liegen noch keine Ergebnisdaten vor.'
                );
            }

            return {
                cssKlasse: 'ausstehend',
                icon: 'square',
                kurztext: 'noch nicht getestet',
                tooltip: Tooltip.html`
                    <p><strong>noch nicht getestet</strong></p>
                    <p>Für diesen Test liegen noch keine Ergebnisdaten vor.</p>
                `
            };
        }

        if (test.has_cbt_angemeldet === 1 || istCbtGruppe) {
            if (geschlechtFehlt) {
                return this.fehlendesGeschlechtStatus(
                    'Geschlecht / CBT-Daten fehlen',
                    'Für diesen CBT-Test wurden bisher keine Ergebnisdaten an das Portal übertragen.'
                );
            }

            return {
                cssKlasse: 'keine-cbt-daten',
                icon: 'square',
                kurztext: 'Keine CBT-Daten',
                tooltip: Tooltip.html`
                    <p><strong>Noch keine CBT-Ergebnisdaten im Portal</strong></p>
                    <p>Für diesen CBT-Test wurden bisher keine Ergebnisdaten an das Portal übertragen.</p>
                `
            };
        }

        if (geschlechtFehlt) {
            return this.fehlendesGeschlechtStatus(
                `Geschlecht / ${this.fehlendeErgebnisseText(anzahlFehlend)}`,
                `Für diesen Test fehlen alle ${anzahlErwartet} erforderlichen Ergebnisse.`
            );
        }

        return {
            cssKlasse: 'keine-daten',
            icon: 'square',
            kurztext: this.fehlendeErgebnisseText(anzahlFehlend),
            tooltip: Tooltip.html`
                <p><strong>Noch keine Ergebnisdaten im Portal</strong></p>
                <p>Für diesen Test fehlen alle <strong>${anzahlErwartet}</strong> erforderlichen Ergebnisse.</p>
            `
        };
    }

    private unvollstaendigerErgebnisstatus(anzahlVorhanden: number, anzahlErwartet: number, anzahlFehlend: number): IErgebnisstatus {
        return {
            cssKlasse: 'unvollstaendig',
            icon: 'exclamation-square',
            kurztext: this.fehlendeErgebnisseText(anzahlFehlend),
            tooltip: Tooltip.html`
                <p><strong>Ergebnisdaten unvollständig</strong></p>
                <p><strong>${anzahlVorhanden}</strong> von <strong>${anzahlErwartet}</strong> erforderlichen Ergebnissen wurden eingegeben. Es ${anzahlFehlend === 1 ? 'fehlt' : 'fehlen'} noch <strong>${anzahlFehlend}</strong>.</p>
            `
        };
    }

    private fehlendesGeschlechtStatus(kurztext: string, ergebnisHinweis: string): IErgebnisstatus {
        return {
            cssKlasse: 'unvollstaendig',
            icon: 'exclamation-square',
            kurztext: kurztext,
            tooltip: Tooltip.html`
                <p><strong>Angaben unvollständig</strong></p>
                <p>Für diese Schülerin oder diesen Schüler wurde kein Geschlecht angegeben.</p>
                <p>${ergebnisHinweis}</p>
            `
        };
    }

    private fehlendeErgebnisseText(anzahlFehlend: number): string {
        return `${anzahlFehlend} ${anzahlFehlend === 1 ? 'Ergebnis fehlt' : 'Ergebnisse fehlen'}`;
    }

    private anzahlErwarteteErgebnisse(test: ISchueler_testsAPI): number {
        const testheft = this.testheftliste.filter(t => t.testheft_id === test.testheft_id)[0] ?? null;
        if (testheft === null)
            return 0;

        const itemIds = testheft.module
            .flatMap(modul => modul.aufgaben)
            .flatMap(aufgabe => aufgabe.items)
            .filter(item => item.zepf_webitem !== null && item.zepf_webitem !== undefined)
            .map(item => item.item_id);

        return new Set(itemIds).size;
    }
}
